import { render, staticRenderFns } from "./CenterFilters.vue?vue&type=template&id=208264d9&scoped=true&"
import script from "./CenterFilters.vue?vue&type=script&lang=ts&"
export * from "./CenterFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CenterFilters.vue?vue&type=style&index=0&id=208264d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208264d9",
  null
  
)

export default component.exports